module.exports = __webpack_public_path__ + "img/ru.ccaf6e4a.svg";